// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.font-values {
  font-family: "OpenSans-Regular";
}

.small {
  margin-left: 10rem;
  padding-left: 1.3em;
  margin-bottom: 5px;
}

.font-values-1 {
  color: var(--undp-jtf-btn-dark-color) !important;
}

.input-group-text {
  color: var(--undp-jtf-btn-dark-color) !important;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/user-signup/user-signup.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACI,+BCGmB;ADAvB;;AACA;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,gDAAA;AAEJ;;AACA;EACI,gDAAA;AAEJ","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../scss/variables';\n.font-values {\n    font-family: $primary-font-regular;\n   // color: var(--undp-jtf-btn-dark-color);\n}\n\n.small{\n    margin-left: 10rem;\n    padding-left: 1.3em;\n    margin-bottom: 5px;\n}\n\n.font-values-1 {\n    color: var(--undp-jtf-btn-dark-color) !important;\n}\n\n.input-group-text {\n    color: var(--undp-jtf-btn-dark-color) !important;\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
